import Vue from 'vue';
import Vuex from 'vuex';
import { imgs } from './assets';
import { lsService } from '@/services/ls.service';

Vue.use(Vuex);

interface Payload {
  key: string;
  data: any;
}

const state: any = {
  imgs,
  pc: {} as pc.Application,
  times: '',
  info: false, // 是否填过信息
  address: 0, // 是否填过地址
  personal_lucky: [], // 个人中奖信息
  missions: [
    {
      title: '谜关Ⅰ',
      mission: [
        {
          shut: 1,
          type: 'game',
          img: `1-1.png`,
          path: '/missionStart/maze',
        },
        {
          shut: 2,
          type: 'game',
          img: `1-2.png`,
          path: '/cube',
        },
        {
          type: 'award',
          active: false,
        },
      ],
    },
    {
      title: '谜关Ⅱ',
      mission: [
        {
          shut: 3,
          type: 'game',
          img: `2-1.png`,
          path: '/missionStart/graphical',
        },
        {
          shut: 4,
          type: 'game',
          img: `2-2.png`,
          path: '/sudoku',
        },
        {
          type: 'award',
          active: false,
        },
      ],
    },
    {
      title: '谜关Ⅲ',
      mission: [
        {
          shut: 5,
          type: 'game',
          img: `3-1.png`,
          path: '/missionStart/crypto',
        },
        {
          type: 'award',
          active: false,
        },
      ],
    },
  ],
  allcheck: [{ shut: 1, clearancetime: 0 }, { shut: 2, clearancetime: 0 }, { shut: 3, clearancetime: 0 }, { shut: 4, clearancetime: 0 }, { shut: 5, clearancetime: 0 }, false, false, false], // 关卡游戏数据
  every_chapter_prize_num: [
    { chapter: 1, chapterprizenum: 0 },
    { chapter: 2, chapterprizenum: 0 },
    { chapter: 3, chapterprizenum: 0 },
    { chapter: 4, chapterprizenum: 0 },
  ], // 奖池数据
  isPlay: true, // 全局音乐暂停
  video: (() => {
    const video = document.createElement('video');
    video.src = require(`@/assets/videos/missionStart.mp4`);
    const attrList = [`playsinline`, `x5-playsinline`, `webkit-playsinline`, `x5-video-player-fullscreen`, `loop`];
    attrList.map(attr => video.setAttribute(attr, `true`));
    return video;
  })(),
  audios: (() => {
    const obj = {};
    [`bgm`, 'typing', 'boom', 'assemble'].map(name => {
      const audio = document.createElement('audio');
      audio.src = require(`@/assets/audios/${name}.mp3`);
      name == 'bgm' && audio.setAttribute(`loop`, `true`);
      obj[name] = audio;
    });
    return obj;
  })(),
};

const getters: any = {
  score: state => {
    // 游戏计时
    let total = 0;
    state.allcheck.map(shut => {
      if (shut && shut.clearancetime) return (total += shut.clearancetime);
    });

    let c1 = state.allcheck[0].clearancetime + state.allcheck[1].clearancetime;
    let c2 = state.allcheck[2].clearancetime + state.allcheck[3].clearancetime;
    let c3 = state.allcheck[4].clearancetime;

    return {
      total,
      c1,
      c2,
      c3,
    };
  },
  gameProgress: state => {
    // 游戏进度 1,2,3,4,5,6
    console.log('state.allcheck', state.allcheck);
    const current = state.allcheck.findIndex(shut => {
      return shut && typeof shut.clearancetime == `number` && shut.clearancetime === 0;
    });
    return current === -1 ? 6 : current + 1;
  },
  version: state => {
    let d1 = new Date('2020/8/26 22:00:00').getTime();
    let d2 = new Date('2020/8/27 18:48:00').getTime();
    if (state.times < d1) return 1; //活动进行中
    if (state.times > d2) return 3; //获奖名单展示
    return 2; //活动结束 获奖名单审核中
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations: {
    update(state, payload: Payload) {
      const { key, data } = payload;
      state[key] = data;
    },
  },
  actions: {
    update(context, payload: Payload) {
      context.commit('update', payload);
      console.log('update', payload);
    },
  },
  modules: {},
});
